// Used in the Collection, Search and Blog pages

/**
 * View mode - Toggle between Primary & Secondary (Product & Lifestyle / Artist & Art) with 1 class toggle
 * The Cards and View buttons are changed with the group tailwind class
 */
if (!customElements.get('card-overview-view')) {
  class CardOverviewView extends HTMLElement {
    constructor() {
      super();

      // check if the current page is a blog or a product overview page and get the variables accordingly
      this.mainCardOverview = this.closest('[data-main-product-overview]');
      this.sessionStorageViewValue = 'productOverviewView';
      if (document.body.classList.contains('template-blog')) {
        this.mainCardOverview = this.closest('[data-main-artist-overview]');
        this.sessionStorageViewValue = 'artistOverviewView';
      }

      this.viewPrimary = this.querySelector('[data-view-primary]');
      this.viewSecondary = this.querySelector('[data-view-secondary]');

      this.viewOptions = [this.viewPrimary, this.viewSecondary];

      // Get the click on the view options
      this.viewOptions.forEach((view) => {
        view.addEventListener('click', () => {
          this.switchView(view);
        });
      });

      // Get the initial class values from the sessionStorage, if there's any set
      this.init();
    }

    init() {
      // if the cardOverviewView is saved to be the Secondary from previous actions, adjust the parent class accordingly
      if (sessionStorage[this.sessionStorageViewValue] == 'secondary')
        this.mainCardOverview.classList.add('cards-wrapper--secondary-view');
    }

    // update the sessionStorage values and the parent class
    switchView(view) {
      if (view == this.viewSecondary) {
        sessionStorage[this.sessionStorageViewValue] = 'secondary';
        this.mainCardOverview.classList.add('cards-wrapper--secondary-view');
      } else {
        sessionStorage[this.sessionStorageViewValue] = 'primary';
        this.mainCardOverview.classList.remove('cards-wrapper--secondary-view');
      }
    }
  }
  customElements.define('card-overview-view', CardOverviewView);
}

/**
 * Layout switch - Toggle between Grid & List with 1 class toggle
 * The Cards and Toggle buttons are changed with the group tailwind class
 */
if (!customElements.get('card-overview-switch')) {
  class CardOverviewSwitch extends HTMLElement {
    constructor() {
      super();
      this.productOverviewFiltersForm = !document.body.classList.contains('template-blog')
        ? document.querySelector('product-overview-filters-form')
        : null;
      this.buttons = this.querySelectorAll('[data-card-overview-view]');
      this.buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.handleButton(button);
        });
      });
    }
    handleButton(button) {
      // Get full current url
      const url = new URL(window.location);
      let params = new URLSearchParams(url.search);
      // Delete view first by default
      params.delete('view');
      const view = button.dataset.cardOverviewView;
      // Update view param when not empty
      if (view != '') params.set('view', view);

      // Render the page again with method from product overview filters form component
      this.productOverviewFiltersForm?.renderPage(params.toString());

      // Reset UI state classes on buttons
      this.buttons.forEach((button) => {
        button.classList.remove('card-overview-layout__button--active', 'text-primary-700');
        button.classList.add('text-gray');
      });
      // Set active state on button
      button.classList.add('card-overview-layout__button--active', 'text-primary-700');
      button.classList.remove('text-gray');
    }
  }
  customElements.define('card-overview-switch', CardOverviewSwitch);
}
